import { render, staticRenderFns } from "./PersonPayrollDirectAssignmentGrid.vue?vue&type=template&id=b20501e8"
import script from "./PersonPayrollDirectAssignmentGrid.vue?vue&type=script&lang=js"
export * from "./PersonPayrollDirectAssignmentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports